const STATUS_META = {
  approved: { label: "Approved", tone: "success" },
  pending: { label: "Pending", tone: "warning" },
  rejected: { label: "Rejected", tone: "danger" },
  "": { label: "—", tone: "muted" },
};

export const ADMIN_LEAVE_TYPE_META = {
  casual_leave: {
    label: "Casual Leave",
    accent: "sky",
    icon: "announcements",
  },
  sick_leave: {
    label: "Sick Leave",
    accent: "amber",
    icon: "documents",
  },
  privilege_leave: {
    label: "Privilege Leave",
    accent: "blue",
    icon: "employees",
  },
  maternity_leave: {
    label: "Maternity Leave",
    accent: "pink",
    icon: "designation",
  },
  comp_off: {
    label: "Comp Off",
    accent: "success",
    icon: "attendance",
  },
  other: {
    label: "Others",
    accent: "muted",
    icon: "documents",
  },
};

export const ADMIN_LEAVE_DURATION_OPTIONS = [
  { value: "full_day", label: "Full Day" },
  { value: "half_day_am", label: "Half Day (AM)" },
  { value: "half_day_pm", label: "Half Day (PM)" },
  { value: "multiple_days", label: "Multiple Days" },
];

export const ADMIN_LEAVE_STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

export function getCurrentMonthKey() {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function formatMonthHeading(monthKey) {
  const [year, month] = String(monthKey || getCurrentMonthKey())
    .split("-")
    .map((value) => Number(value));

  return new Intl.DateTimeFormat("en-IN", {
    month: "long",
    year: "numeric",
  }).format(new Date(year, month - 1, 1));
}

export function getLeaveStatusMeta(status) {
  return STATUS_META[status] || STATUS_META[""];
}

export function getAdminLeaveTypeMeta(leaveType) {
  return ADMIN_LEAVE_TYPE_META[leaveType] || ADMIN_LEAVE_TYPE_META.other;
}

export function formatLeaveDays(value) {
  const amount = Number(value || 0);
  return Number.isInteger(amount) ? String(amount) : amount.toFixed(1);
}

export function createLeavesDonutStyle(metrics) {
  const approved = Number(metrics?.approvedRequests || 0);
  const pending = Number(metrics?.pendingRequests || 0);
  const rejected = Number(metrics?.rejectedRequests || 0);
  const total = Math.max(1, Number(metrics?.totalRequests || 0));

  const values = [
    ["#6acb7c", (approved / total) * 100],
    ["#ffbf47", (pending / total) * 100],
    ["#ff6d6d", (rejected / total) * 100],
  ];

  let cursor = 0;
  const stops = values
    .filter(([, size]) => size > 0)
    .map(([color, size]) => {
      const stop = `${color} ${cursor}% ${cursor + size}%`;
      cursor += size;
      return stop;
    });

  return `conic-gradient(${stops.join(", ") || "#edf0f5 0% 100%"})`;
}

export function parseLeavesCsv(text) {
  return String(text || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(1)
    .map((line) => {
      const parts = line.split(",").map((part) => part.trim().replace(/^"|"$/g, ""));

      return {
        employeeId: parts[0] || "",
        leaveType: parts[1] || "",
        duration: parts[2] || "",
        fromDate: parts[3] || "",
        toDate: parts[4] || "",
        status: parts[5] || "",
        reason: parts[6] || "",
      };
    })
    .filter((row) => row.employeeId && row.leaveType && row.fromDate);
}

export function downloadLeavesCsv(fileName, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
